module.exports = __webpack_public_path__ + "assets/Entertainment.1945a5d5.svg";